import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import { ToastProvider } from './components/Toast';
import App from './App';
import './styles/global.css';
import './styles/utilities.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

// Selalu gunakan createRoot — bukan hydrateRoot.
// App ini fetch data dinamis dari WordPress; HTML prerender react-snap tidak
// pernah cocok dengan render client sehingga hydrateRoot memicu error #418/#423/#425.
// react-snap tetap berguna untuk SEO (crawler mendapat HTML statis),
// tapi user mendapat React rendering bersih tanpa crash.
const root = createRoot(rootElement);
root.render(
  <ErrorBoundary>
    <React.StrictMode>
      <HelmetProvider>
        <ToastProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ToastProvider>
      </HelmetProvider>
    </React.StrictMode>
  </ErrorBoundary>
);

